export default __webpack_public_path__ + "static/media/gallery_00.31292e75.jpg";